import icons from "../../img/icons.svg";

export default class View{
    _data;
    // Public Methods
    render(data){

        if(!data || (Array.isArray(data) && data.length===0)) return this.renderError()
        this._data=data
        const markup=this._generateMarkUp();
        this._clear()
        this._parentElement.insertAdjacentHTML("afterbegin",markup);
    }

    update(data){
        if(!data || (Array.isArray(data) && data.length===0)) return this.renderError();
        this._data=data
        const newMarkup=this._generateMarkUp();

        // Converting String Markup Into A DOM Node Object that will be stored into the memory
        // Virtually DOM, it only exist in the Memory

        const newDOM=document.createRange().createContextualFragment(newMarkup);
        const newElements=Array.from(newDOM.querySelectorAll("*"));
        const curElements=Array.from(this._parentElement.querySelectorAll("*"))
        // console.log(newElements,curElements)

        newElements.forEach((newEl,i)=>{
            const curEl=curElements[i];

            // Updates changed Text
            if(!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== ""){
                // console.log(newEl.firstChild?.nodeValue.trim())
                curEl.textContent=newEl.textContent
            }

            // Updates Changed ATTRIBUTES
            if(!newEl.isEqualNode(curEl)){
                Array.from(newEl.attributes).forEach(attr=>{
                    curEl.setAttribute(attr.name,attr.value)
                })
            } 

        })


    }
    
    renderSpinner=()=>{
        const markup=`
            <div class="spinner">
                <svg>
                  <use href="${icons}#icon-loader"></use>
                </svg>
            </div>
        `
        this._parentElement.innerHTML="";
        this._parentElement.insertAdjacentHTML("afterbegin",markup);  
    }
    
    renderError(message=this._errorMesssage){
        const markup=`<div class="error">
            <div>
              <svg>
              <use href="${icons}#icon-alert-triangle"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>`;
    
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin",markup);  
    };
    
    _clear(){
        this._parentElement.innerHTML="";
    }
}

